export const MODEL_CONFIG = {
  modelo1: {
    label: "Lavadora",
    url: "/models/Lavadora2.gltf",
    targetIndex: 0,
    scale: "0.8 0.8 0.8",
    rotation: "0 0 0",
    position: "0 0 0.1",
    color: "#4ECDC4",
  },
  modelo2: {
    label: "Demo",
    url: "/models/demo_model.glb",
    targetIndex: 1,
    scale: "0.15 0.15 0.15",
    rotation: "0 0 0",
    position: "0 0 0.05",
    color: "#FF6B6B",
  },
  modelo3: {
    label: "Lavamanos",
    url: "/models/lavamano.glb",
    targetIndex: 2,
    scale: "0.5 0.5 0.5",
    rotation: "0 0 0",
    position: "0 0 0.1",
    color: "#A8E6CF",
  },
};

export const AR_CONFIG = {
  targetSrc: "/targetsx3.mind",
  maxTrack: 1,
  uiLoading: "yes",
  uiScanning: "yes",
  uiError: "yes",
};
